import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import ImportsList from '../../Components/Imports/imports-list';
import ImportsFilters from '../../Components/Imports/imports-filters';
import { useApi } from '../../Components/Hooks/useApi';
import { usePagination } from '../../Components/Hooks/usePagination';
import * as url from '../../helpers/url_helper';

const ImportsPage = ({ t }) => {
  const { get } = useApi();
  const pagination = usePagination();

  const [imports, setImports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    status: '',
    identifier: '',
  });

  const fetchImports = async () => {
    try {
      setLoading(true);
      setError(null);
      const params = {
        ...pagination.pageOptions,
        filters: {
          status: filters.status ? { in: [filters.status] } : undefined,
          identifier: filters.identifier ? { in: [filters.identifier] } : undefined,
        },
      };

      const response = await get(url.REPORT_IMPORTS, params);
      setImports(response.data || []);
      pagination.setTotal(response.meta?.total || 0);
    } catch (error) {
      console.error('Error fetching imports:', error);
      setError('Não foi possível carregar as importações. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchImports();
  }, [pagination.pageOptions, filters]);

  document.title = 'Importações | Opencashback';

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={t('imports.title', 'Importações')}
            pageTitle={t('imports.page-title', 'Importações')}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <ImportsFilters
                    filters={filters}
                    onFiltersChange={setFilters}
                  />

                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}

                  <ImportsList
                    imports={imports}
                    loading={loading}
                    pagination={pagination}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ImportsPage);
